import React, { useContext, useEffect, useState } from "react";
import Description from "./Description";
import Specification from "./Specification";
import Reviews from "./Reviews";
import NoVariation from "./HeroComponent/NoVariation";
import ColorVariation from "./HeroComponent/ColorVariation";
import BothVariation from "./HeroComponent/BothVariation";

const BothType = ({ data }) => {
  const [count, setCount] = useState(0);
  const showcomponent = [
    <Description data={data} />,
    <Specification data={data} />,
    <Reviews data={data} />,
  ];

  return (
    <div className="single-product-main-content overflow-hidden px-2">
      <div className="layout">
        <div>
          <BothVariation data={data} />
        </div>
        <div className=" flex gap-5 text-red-500 border-b  border-red-400 pb-5  mt-20 ">
          <div
            className={` ${count == 0 ? " border-b-2 border-red-300  " : "border-white"
              } uppercase cursor-pointer `}
            onClick={() => setCount(0)}
          >
            Description
          </div>
          <div
            className={` ${count == 1 ? " border-b-2 border-red-300  " : "border-white"
              } uppercase cursor-pointer`}
            onClick={() => setCount(1)}
          >
            specification{" "}
          </div>
          <div
            className={` ${count == 2 ? " border-b-2 border-red-300  " : "border-white"
              } uppercase cursor-pointer`}
            onClick={() => setCount(2)}
          >
            Review{" "}
          </div>
        </div>
        {showcomponent[count]}
      </div>
    </div>
  );
};

export default BothType;
